import React from 'react';
import { SnackbarProvider } from 'notistack';
import ManageOrders from './ManageOrders.js';

export default function ManageOrdersWithSnackbar(){
    return <SnackbarProvider maxSnack={3} key={new Date()}>
        <ManageOrders />
    </SnackbarProvider>
}